export default __webpack_public_path__ + "static/media/ochre.55020793.webp";